export default __webpack_public_path__ + "3bc00c2423aa702eb0f5a3e9afae0ac4.svg";